import { lazy } from 'react';
import { Route } from 'react-router-dom';

const PostType = lazy(() => import('../PostCreateRevanp/PostType'));
const RevampPostCreate = lazy(() => import('../PostCreateRevanp/RevampPostCreate'));
const SchemePostCreate = lazy(() => import('../PostCreateRevanp/SchemePostCreate.js'));
const FMCGChangesPostCreate = lazy(() => import('../PostCreateRevanp/FMCGChangesPostCreate'));
const TejiMandiCreate = lazy(() => import('../PostCreateRevanp/TejiMandiCreate.js'));
const TejiMandiRujhanPostCreate = lazy(
	() => import('../PostCreateRevanp/TejiMandiRujhanPostCreate')
);
const UserPosts = lazy(() => import('../PostCreateRevanp/UserPosts'));
const CreatePost = lazy(() => import('../components/CreatePost'));

const postCreationRoutes = (
	<>
		<Route path="/post/create" element={<CreatePost />} />
		<Route path="/revampPost/type" element={<PostType />} />
		<Route path="/revampPost/create" element={<RevampPostCreate />} />
		<Route path="/revampPost/create/scheme" element={<SchemePostCreate />} />
		<Route path="/revampPost/create/tejimandi" element={<TejiMandiCreate />} />
		<Route path="/revampPost/create/fmcg-changes" element={<FMCGChangesPostCreate />} />
		<Route path="/revampPost/create/teji-mandi-rujhan" element={<TejiMandiRujhanPostCreate />} />
		<Route path="/revampPost/userPosts" element={<UserPosts />} />
	</>
);

export default postCreationRoutes;
